import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 16 16" focusable="false" fill="currentColor" aria-hidden="true"><g fillRule="nonzero" fill="none"><path d="M2.275 0C1.575 0 1 .55 1 1.25v13.475c0 .7.575 1.275 1.275 1.275h11.45c.7 0 1.275-.575 1.275-1.275v-9.65L10.275 0h-8Z" fill="#E986A5" /><path d="m9.74 9.65-3.052 2.882L5.51 10.82a.044.044 0 0 0-.058 0l-1.439 2.756c-.026.024-.007.065.03.065h7.917c.036 0 .055-.04.029-.065l-2.19-3.924a.044.044 0 0 0-.058 0ZM4.81 8.7a.7.7 0 1 0 1.4 0 .7.7 0 0 0-1.4 0Z" fill="#FFF" /><path d="M10.275 0v3.65c0 .4.275 1.45 1.525 1.45H15L10.275 0Z" fill="#FFC9DA" /></g></svg>

const Image = React.forwardRef((props, ref) => {
  return (
    <IconBase name="image" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

Image.displayName = 'IconImage'

export default Image
